module.exports = __webpack_public_path__ + "static/img/IMG_20150307_174621.819bfdea.jpg";